<div id="tarteaucitronAlertBig" class="privacy-popup">
  <a id="tarteaucitronAllDenied2" class="skip-privacy close-popup">
      <span>Continuer sans accepter</span><fa-icon [icon]="faArrowRight"></fa-icon>
  </a>
  <p class="h2-like">Politique de confidentialité</p>
  <p><strong>Ubilaw.com</strong> utilise des cookies pour mesurer son audience. Nous ne transmettons vos données à aucun tiers parti.</p>
  <p>Vous avez le choix de les accepter ou de les refuser.</p>
  <p>En cliquant sur “Tout accepter”, vous consentez à l'utilisation des cookies. Vous pouvez regarder en détail notre <a id="tarteaucitronPrivacyUrl" routerLink="/politique-de-confidendialite">politique de confidentialité</a>.</p>
  <p>Vous pouvez gérer vos choix en cliquant sur “Paramétrer les cookies” ou tout refuser en cliquant sur “Continuer sans accepter”.</p>
  <div class="popup-actions">
      <a id="tarteaucitronCloseAlert" class="btn btn-outline close-popup">Paramétrer les cookies</a>
      <a id="tarteaucitronPersonalize2" class="btn btn-primary close-popup">Tout accepter</a>
  </div>
</div>
